import type { PosCheckoutAttempt } from '../types';

/**
 * Câu báo cho mọi cổng chặn dựa trên `checkoutAttempt` — MỘT chỗ dựng, vì ba
 * tình huống dưới đây từng dùng chung đúng một câu và câu đó chỉ đúng cho tình
 * huống đầu tiên:
 *
 *  - có `reconciliationStatus`: đơn ĐÃ vào sổ, khuyến mãi chưa chốt xong. Sửa
 *    dữ liệu rồi ghi lại sẽ đẻ ra đơn thứ hai ⇒ đúng là phải đóng đơn, tạo lại;
 *  - có snapshot nhưng KHÔNG có `reconciliationStatus`: lần ghi trước không
 *    nhận được kết quả (mất mạng/5xx). Có thể đơn đã vào sổ, có thể chưa — thu
 *    ngân cần đi tra danh sách đơn, không phải nghe về "đối soát khuyến mãi";
 *  - KHÔNG có snapshot: giỏ hàng/form đổi giữa lúc validate và lúc gọi API
 *    (thu ngân bấm thêm hàng, giá vàng làm mới…). Chưa có gì được ghi cả, bấm
 *    lại là xong — đóng đơn ở đây là mất trắng dữ liệu đã nhập cho không.
 */
export function checkoutLockMessage(attempt: PosCheckoutAttempt | undefined): string {
  if (!attempt) {
    return 'Dữ liệu đơn vừa thay đổi trong lúc ghi hoá đơn — vui lòng kiểm tra lại và bấm ghi hoá đơn lần nữa.';
  }
  if (attempt.reconciliationStatus) {
    return 'Đơn đang chờ đối soát — không thể sửa thông tin hoặc số tiền của lần ghi này. Vui lòng đóng đơn và tạo lại.';
  }
  return 'Lần ghi trước chưa rõ kết quả — không thể sửa thông tin hoặc số tiền của lần ghi này. Kiểm tra danh sách đơn hàng, nếu đơn chưa được ghi thì bấm "Bỏ khoá và sửa lại".';
}
